import { Avatar, Col, Divider, Row,Spin } from 'antd'
import InfoCards from 'components/InfoCards'
import CheckTick from 'components/icons/CheckCircleIcon'
import {
  ColContainer,
  ContentCenterDiv,
  Head1,
  Head2,
  PendingStyle,
  Profile,
  Profile1,
  RightDiv1,
  RightDiv2,
  RowContainer,
  SectionWrapper,
  Spacingdiv,
  TopHeading,
} from 'modules/Dashboard/Style/style'
import SingleListed from 'modules/Roles/Style/singleListed'
import React, { useEffect, useState } from 'react'
import { actionDrawerProps, showDrawerProps } from '../../utils/constants'

import Button from 'components/Button'
import CalenderStyled from 'components/CalenderStyled'
import CheckCircle from 'components/icons/CheckCircle'
import EmptyStateImage from 'components/icons/EmptyState'
import WorkCloseIcon from 'components/icons/WorkCloseIcon'
import WorkRoleActive from 'components/icons/WorkRoleActive'
import WorkRoleActive1 from 'components/icons/WorkRoleActive1'
import WorkOfferIcon from 'components/icons/WorkOfferIcon'
import WorkTickIcon from 'components/icons/WorkTickIcon'
import WorkRoleReject from 'components/icons/WorkRoleReject'
import WorkRoleAbsent from 'components/icons/WorkRoleAbsent'
import WorkIntent from 'components/icons/WorkIntent'
import WorkRecived from 'components/icons/WorkRecived'
import WorkRejected from 'components/icons/WorkRejected'
import WorkAccepted from 'components/icons/WorkAccepted'
import PercentageChart from 'modules/Dashboard/Style/PercentageChart'
import UpcomingList from 'modules/Dashboard/Style/UpcomingList'
import moment from 'moment'
import { Link } from 'react-router-dom'
import ActionRoleDrawer from '../../components/UIElements/ActionRoleDrawer'
import BlacklistMessageComponent from './Style/BlackListComponent'
import OptoutNotification from './Style/OptoutNotification'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import CvProgressModal from 'modules/Roles/Style/CvProgressModal'
import PopModal from 'modules/Roles/Style/PopModal'
import ProfileFormModal from 'modules/Roles/Style/ProfileFormModal'
// Spinner container with centered positioning
const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30vh;
  width: 100%;
`
const MetrixText = styled.div`
  font-family: Plus Jakarta Sans;
font-weight: 500;
font-size: 14px;
line-height: 100%;
letter-spacing: 0%;
color: #999FAC;
margin-bottom: 10px;
`


const Dashboard = ({
  ApplyRole,
  SaveRole,
  getRolesList,
  rolesList,
  getSingleRoleDetails,
  getAppliedRoleMetrics,
  dashboardMetric,
  getStudentData,
  studentDetails,
  studentData,
  getDrivesList,
  drivesList,
  collegeData,
  getRoleFloatDetails,
  getEligibleDetails,
  getFunctionsList,
  functionsList,
  getListOfSkills,
  studentDetail,
  updateStudentData,
  updateRoleFloatDetails,
  getStudentRoleList,
  getCompTypeList,
  updateStudent,
  getStudentRuleSet,
  optoutStatus,
  studentOptedStatus,
  updateOptedStatus,
  updateOptedWitdrawStatus,
  rejectStudentStatus,
  getListOfCountries,
  getListOfState,
  getListOfCity,
  searchAPI,
  updateCvDetails,
  deleteEducation,
  getCities,
  countryList,
  stateList,
  updateCurrentState,
  updateStatusPending,
  updateUserProfile,
  getDesignationsList
}) => {
  const isOptOut = optoutStatus?.optoutStatus?.currentCourse?.optOutStatus

  const [calendarValue, setCalendarValue] = useState(moment().unix())
  const [loading, setLoading] = useState(false)
  const [roleListData, setRoleListData] = useState([])
  const [roleTypewithComp, setRoleTypeWithComp] = useState([])
  const [studentFullRules, setStudentFullRules] = useState(null)
  const [exceptionBrand, setExceptionBrand] = useState([])
  const [showDrawer, setShowDrawer] = useState(false)

  const [actionDrawer, setActionDrawer] = useState(false)
  const [initialLoading, setInitialLoading] = useState(true)
  const [studentFullData , setStudentFullData] = useState(null)
  const campusDetails = useSelector(state => state?.studentData?.campusDetails)
  const accessLevel = campusDetails?.instituteSubscription?.accessLevel
  const studentId = useSelector(state => state?.auth?.studentId)
  // Profile checklist flags — single source of truth for the green ticks in the
  // right panel and for the activation gate on the opt-in "Proceed" action.
  const hasPersonalInfo = Boolean(
    studentData?.studentPersonalProfile?.isAnywhere ||
      studentData?.studentPersonalProfile?.preferredJobLocation?.some(
        item => item?.city_id || item?.state_id
      )
  )
  const hasEducation = studentData?.education?.length > 0
  const canActivateStudent = hasPersonalInfo && hasEducation
  const [modalVisibleData, setModalVisibleData] = useState(false)
  const [profileFormModalVisible, setProfileFormModalVisible] = useState(false)
  const [cvProgVisible, setCvProgVisible] = useState(false)
  const [cvProgPercent, setCvProgPercent] = useState(0)
  const onDateSelected = date => {
    setCalendarValue(date)
  }

 

  useEffect(() => {
    fetchStudentFullData()
  }, [modalVisibleData])

  const fetchStudentFullData = async () => {
    let result = await getStudentData()
    setStudentFullData(result)
  }
  const handleSubmit = () => {
    console.log('submit')
  }
  useEffect(() => {
    if (typeof isOptOut !== 'undefined' && isOptOut === null) {
      setShowDrawer(true)
    }
  }, [isOptOut])

  useEffect(() => {
    // Show spinner for 1 second
    const timer = setTimeout(() => {
      setInitialLoading(false)
    }, 1000)
    
    // Clear timeout if component unmounts
    return () => clearTimeout(timer)
  }, [])
  useEffect(() => {
    fetchRoleListData()
  }, [studentFullRules])

  useEffect(() => {
    fetchInitialComType()
  }, [])

  useEffect(() => {
    fetchStudentRuleSet()
  }, [])

  const fetchStudentRuleSet = async () => {
    let result = await getStudentRuleSet()
    setStudentFullRules(result?.data?.data)
  }

  const handleConfirmDelete = () => {
    setShowDrawer(false)
    setActionDrawer(true)
  }
  const handleApprove = async (value, reason) => {
    const payload = {
      isOptOut: true,
      optoutType: value,
      optoutReason: reason,
    }
    await updateOptedStatus(payload)
    await studentOptedStatus()
    setActionDrawer(false)
  }
  const fetchInitialComType = async () => {
    let result = await getCompTypeList()
    setExceptionBrand(result?.data?.data?.instituteRule?.brands?.list)
    setRoleTypeWithComp(
      result?.data?.data?.instituteRule?.compensationThreshold?.isEnabled
        ? result?.data?.data?.instituteRule?.compensationThreshold
            ?.compensationList
        : []
    )
  }
  const fetchRoleListData = async () => {
    let payLoad = {
      pageLimit: 10,
      pageNo: 0,
    }
    if (studentFullRules) {
      payLoad.multiplesAmount = studentFullRules?.offerLimit?.multiplesAmount
      payLoad.absoluteAmount = studentFullRules?.offerLimit?.absoluteAmount
      payLoad.compensationMinAmount =
        studentFullRules?.offerLimit?.compensationMinAmount
      payLoad.compensationLimitReached =
        studentFullRules?.offerLimit?.compensationLimitReached
      payLoad.exceptionalBrandsThreshold =
        studentFullRules?.offerLimit?.exceptionalBrandsThreshold
    }
    if (studentFullRules?.offerLimit?.isOfferRuleActive)
      payLoad.isOfferRuleActive =
        studentFullRules?.offerLimit?.isOfferRuleActive

    setLoading(true)
    let result = await getStudentRoleList(payLoad)
    setRoleListData(result?.data?.data || [])
    setLoading(false)
  }
  useEffect(() => {
    getAppliedRoleMetrics()
    getStudentData()
    studentOptedStatus()
    // Preload modal data for faster opening
    getListOfCountries('', true, () => {})
    getListOfState('', '', true, () => {})
    getListOfSkills('', () => {})
    // getRolesList({
    //   page: 0,
    //   sortValue: '',
    //   search: '',
    //   jobTypeLevel: [],
    //   jobType: '',
    //   minCTC: 0,
    //   maxCTC: 50,
    //   locationFilter: '',
    //   setLoading,
    // })
    getDrivesList({
      occurrence: 'UPCOMING',
      driveModeList: '',
      date: '',
      page: 0,
      setLoading,
    })
  }, [])

  const UpdatedSkills = () => {
    fetchRoleListData()
  }
  const closeValidation = () => {
    setActionDrawer(false)
    setShowDrawer(true)
  }

  const setTextDate = () => {
    let today = new Date()
    let curHr = today.getHours()
    if (curHr < 12) {
      return <span>Good Morning</span>
    } else if (curHr < 18) {
      return <span>Good Afternoon</span>
    } else {
      return <span>Good Evening</span>
    }
  }
  // Opting in activates the student only once the mandatory checklist items
  // (Personal Information + Education) are ticked.
  const activateStudentIfProfileReady = async () => {
    if (!canActivateStudent || !studentId) {
      return
    }
    if (studentFullData?.currentState >= 4) {
      return
    }
    const isActivated = await updateCurrentState(studentId, 4)
    if (isActivated === true) {
      fetchStudentFullData()
    }
  }
  const handleCloseDrawer = async () => {
    const payload = {
      isOptOut: false,
    }
    await updateOptedStatus(payload)
    await studentOptedStatus()
    setShowDrawer(false)
    await activateStudentIfProfileReady()
  }
  const handleClose = () => {
    setActionDrawer(false)
  }
  return (
    <SectionWrapper column>
      <Row>
        <Col span={24}>
          <Head1>My Dashboard</Head1>
          <Head2>
            {setTextDate()}, {studentData?.admin?.firstName}!
          </Head2>
          <RowContainer>
            <Col md={24} lg={24}>
              <Row>
                <ColContainer md={3} lg={3} >
                  <InfoCards
                    width={'100%'}
                    padding={'15px'}
                    icon={<WorkRoleActive />}
                    text={'Applied Jobs'}
                    value={dashboardMetric?.appliedCount}
                    // clickIcon={true}
                    // navigation={'/applied_roles/ACTIVE'}
                  />
                </ColContainer>
                <ColContainer md={3} lg={3} border={true}>
                <MetrixText>Evaluation Process</MetrixText>
                  <InfoCards
                    width={'100%'}
                    padding={'15px'}
                    icon={<WorkRoleActive1 />}
                    text={'Roles - Active'}
                    value={dashboardMetric?.activeCount}
                    // clickIcon={true}
                    // navigation={'/applied_roles/SHORTLISTED'}
                  />
                </ColContainer>
                <ColContainer md={3} lg={3}>
                  <InfoCards
                    width={'100%'}
                    padding={'15px'}
                    icon={<WorkRoleReject />}
                    text={'Roles - Rejected'}
                    // clickIcon={true}
                    // navigation={'/applied_roles/HELD_TO_COMPARE'}
                    value={dashboardMetric?.rejectedCount}
                  />
                </ColContainer>
                <ColContainer md={3} lg={3}>
                  <InfoCards
                    width={'100%'}
                    padding={'15px'}
                    icon={<WorkRoleAbsent />}
                    text={'Roles - Absent'}
                    value={dashboardMetric?.absentCount}
                    // clickIcon={true}
                    // navigation={'/applied_roles/REJECTED'}
                  />
                </ColContainer>
                <ColContainer md={3} lg={3} border={true}>
                <MetrixText>Offers</MetrixText>
                  <InfoCards
                    width={'100%'}
                    padding={'15px'}
                    icon={<WorkIntent />}
                    text={'Intent to Offer'}
                    // clickIcon={true}
                    // navigation={'/offerReceived'}
                    value={dashboardMetric?.intentToOfferCount}
                  />
                </ColContainer>

                <ColContainer md={3} lg={3}>
                  <InfoCards
                    width={'100%'}
                    padding={'15px'}
                    icon={<WorkRecived />}
                    text={'Received'}
                    // clickIcon={true}
                    // navigation={'/offerReceived/ACCEPTED'}
                    value={dashboardMetric?.offerIssuedCount}
                  />
                </ColContainer>
                <ColContainer md={3} lg={3}>
                  <InfoCards
                    width={'100%'}
                    padding={'15px'}
                    icon={<WorkAccepted />}
                    text={'Accepted'}
                    // clickIcon={true}
                    // navigation={'/offerReceived/REJECTED'}
                    value={dashboardMetric?.offerAcceptedCount}
                  />
                </ColContainer>
                <ColContainer md={3} lg={3}>
                  <InfoCards
                    width={'100%'}
                    padding={'15px'}
                    icon={<WorkRejected />}
                    text={'Rejected'}
                    // clickIcon={true}
                    // navigation={'/offerReceived/REJECTED'}
                    value={dashboardMetric?.offerRejectedCount}
                  />
                </ColContainer>
              </Row>
            </Col>
            {/* <Col md={15} lg={12}>
                <div>
                  {dashboardMetric?.applied != undefined ? (
                    <DoughtChart dashboardMetric={dashboardMetric} />
                  ) : (
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                  )}
                </div>
              </Col> */}
          </RowContainer>

          <BlacklistMessageComponent
            studentDetails={studentDetails}
            optOutStatus={optoutStatus}
            onAction={rejectStudentStatus}
          />
          </Col>
          {initialLoading ? (
      <SpinnerContainer>
        <Spin />
      </SpinnerContainer>
    ) : (   
<Row style={{width:'100%'}}>
  <Col span={18}>
 
          <SingleListed
            DataList={roleListData}
            ApplyRole={ApplyRole}
            SaveRole={SaveRole}
            getSingleRoleDetails={getSingleRoleDetails}
            collegeData={collegeData}
            getAppliedRoleMetrics={getAppliedRoleMetrics}
            getRoleFloatDetails={getRoleFloatDetails}
            getEligibleDetails={getEligibleDetails}
            getFunctionsList={getFunctionsList}
            updateRoleFloatDetails={updateRoleFloatDetails}
            UpdatedSkills={UpdatedSkills}
            studentDetail={studentDetail}
            updateStudentData={updateStudentData}
            functionsList={functionsList}
            getListOfSkills={getListOfSkills}
            loading={loading}
            studentData={studentDetails}
            fetchRoleListData={fetchRoleListData}
            roleTypewithComp={roleTypewithComp}
            updateStudent={updateStudent}
            studentFullRules={studentFullRules}
            exceptionBrand={exceptionBrand}
            fetchStudentRuleSet={fetchStudentRuleSet}
            optOutStatus={optoutStatus}
          />
          
          {rolesList?.result?.length === 0 ? (
            <>
              <>
                <ContentCenterDiv>
                  <EmptyStateImage />
                </ContentCenterDiv>
                <ContentCenterDiv>No Data Found</ContentCenterDiv>
              </>
              <ContentCenterDiv>
                <br></br>

                <Button.Secondary
                  disabled={true}
                  text={'View All'}
                  width={'120px'}
                />

                <br></br>
              </ContentCenterDiv>
            </>
          ) : (
            <ContentCenterDiv>
              <br></br>
              <Link to="/roles">
                <Button.Secondary text={'View All'} width={'120px'} />
              </Link>

              <br></br>
            </ContentCenterDiv>
          )}
         </Col>
         <Col span={6}>
          <RightDiv1>
            {isOptOut == 2 && (
              <OptoutNotification
                studentData={studentDetails}
                updateOptedWitdrawStatus={updateOptedWitdrawStatus}
                isOptOut={isOptOut}
                studentOptedStatus={studentOptedStatus}
              />
            )}
            {studentFullData?.currentState < 4 && (
              <RightDiv2>
              To apply for jobs, make sure to fill these
              fields.
              </RightDiv2>
            )}
            <Spacingdiv>
              <TopHeading flexStart>
                {hasPersonalInfo ? (
                  <Avatar size={20} src={<CheckTick />} />
                ) : (
                  <Avatar size={17} src={<CheckCircle />} />
                )}
                <PendingStyle>Personal Information </PendingStyle>
              </TopHeading>

              <TopHeading flexStart>
                {hasEducation ? (
                  <Avatar size={17} src={<CheckTick />} />
                ) : (
                  <Avatar size={20} src={<CheckCircle />} />
                )}
                <PendingStyle>Education </PendingStyle>
              </TopHeading>

              <TopHeading flexStart>
                {(studentData?.resume?.internships?.length > 0 || studentData?.resume?.projects?.length > 0) ? (
                  <Avatar size={17} src={<CheckTick />} />
                ) : (
                  <Avatar size={20} src={<CheckCircle />} />
                )}
                <PendingStyle>Project & Internship </PendingStyle>
              </TopHeading>

              <TopHeading flexStart>
                {studentData?.resume?.workExperience?.length > 0 ? (
                  <Avatar size={17} src={<CheckTick />} />
                ) : (
                  <Avatar size={20} src={<CheckCircle />} />
                )}
                <PendingStyle>Work Experience </PendingStyle>
              </TopHeading>

              {/* <TopHeading flexStart>
                {studentData?.studentPersonalProfile?.addressProof !=
                  undefined &&
                studentData?.studentPersonalProfile?.addressProof?.length ==
                  0 ? (
                  <Avatar size={20} src={<CheckCircle />} />
                ) : (
                  <Avatar size={17} src={<CheckTick />} />
                )}
                <PendingStyle>Documents</PendingStyle>
              </TopHeading> */}
              {studentFullData?.currentState < 4 && (accessLevel === 1 || accessLevel === 3) && (
              
                <Button.Secondary text={'Complete Now'} onClick={() => setModalVisibleData(true)} width={'100%'} />
             
              )}
              {studentFullData?.currentState < 4 && (accessLevel === 0 || accessLevel === 2) && (
              <Button.Secondary text={'Complete Now'} onClick={() => setProfileFormModalVisible(true)} width={'100%'} />
              )}
            </Spacingdiv>
            {studentFullData?.currentState === 4 && (
            <RightDiv2>
            Start applying for jobs now!
         </RightDiv2>
            )}
           
          </RightDiv1>
        </Col> 
         </Row>
            )}
        
      
      </Row>
      <ActionRoleDrawer
        showDrawer={actionDrawer}
        setShowDrawer={setActionDrawer}
        {...actionDrawerProps}
        onApprove={handleApprove}
        onCloseClick={handleClose}
        closeValidation={closeValidation}
      />
      <ActionRoleDrawer
        showDrawer={showDrawer}
        setShowDrawer={setShowDrawer}
        onCloseClick={handleConfirmDelete}
        {...showDrawerProps}
        handleCloseDrawer={handleCloseDrawer}
      />

      
            {cvProgVisible && (
              <CvProgressModal visible={cvProgVisible} progress={cvProgPercent} />
            )}
            <PopModal
        visible={modalVisibleData}
        onClose={() => setModalVisibleData(false)}
        onSubmit={handleSubmit}
        studentData={studentDetails}
        studentFormData={studentDetail}
        getListOfCountries={getListOfCountries}
        getListOfState={getListOfState}
        getListOfCity={getListOfCity}
        searchAPI={searchAPI}
        getListOfSkills={getListOfSkills}
        countryList={countryList}
        stateList={stateList}
        updateStudentData={updateStudentData}
        updateCvDetails={updateCvDetails}
        getStudentData={getStudentData}
        deleteEducation={deleteEducation}
        getCities={getCities}
        updateUserProfile={updateUserProfile}
        onStartCvUpload={() => {
          // open progress modal & close form
          setCvProgPercent(0)
          setCvProgVisible(true)
          setModalVisibleData(false) // closes ProfileFormModal
        }}
        onCvProgress={p => setCvProgPercent(p)} // update %
        onFinishCvUpload={() => {
          // close progress & reopen form
          setCvProgVisible(false)
          setModalVisibleData(true)
        }}
        cvDetails={studentDetails?.cvDetails}
        updateCurrentState={updateCurrentState}
        updateStatusPending={updateStatusPending}
        setModalVisibleData={setModalVisibleData}
        getDesignationsList={getDesignationsList}
      />
      <ProfileFormModal
        visible={profileFormModalVisible}
        onClose={() => setProfileFormModalVisible(false)}
        onSubmit={handleSubmit}
        studentData={studentDetails}
        studentFormData={studentDetail}
        getListOfCountries={getListOfCountries}
        getListOfState={getListOfState}
        getListOfCity={getListOfCity}
        searchAPI={searchAPI}
        getListOfSkills={getListOfSkills}
        countryList={countryList}
        stateList={stateList}
        updateStudentData={updateStudentData}
        updateCvDetails={updateCvDetails}
        getStudentData={getStudentData}
        deleteEducation={deleteEducation}
        getCities={getCities}
        onStartCvUpload={() => {
          // open progress modal & close form
          setCvProgPercent(0)
          setCvProgVisible(true)
          setProfileFormModalVisible(false)
        }}
        onCvProgress={p => setCvProgPercent(p)} // update %
        onFinishCvUpload={() => {
          // close progress & reopen form
          setCvProgVisible(false)
          setProfileFormModalVisible(true)
        }}
        cvDetails={studentDetails?.cvDetails}
        updateCurrentState={updateCurrentState}
        updateStatusPending={updateStatusPending}
        setModalVisibleData={setProfileFormModalVisible}
        getDesignationsList={getDesignationsList}
      />
    </SectionWrapper>
  )
}
export default Dashboard
